import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'analytics',
});

export const pageDetailRouteRef = createRouteRef({
  id: 'analytics-page-detail',
  params: ['page'],
});

export const userDetailRouteRef = createRouteRef({
  id: 'analytics-user-detail',
  params: ['user'],
});
